﻿import { Component, ViewChild } from '@angular/core';
import { ProviderDto } from 'src/app/dtos/provider-dto';
import { DataTableComponent } from 'src/app/shared/data-table/data-table.component';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material';
import { ApiService } from 'src/app/core/services/api.service';
import { MessageService } from 'src/app/core/services/message.service';
import { ConfirmDialogComponent } from '../../../shared/confirm-dialog/confirm-dialog.component';

@Component({
    selector: 'providers',
    templateUrl: './providers.component.html',
    styleUrls: ['./providers.component.scss']
})

export class ProvidersComponent {
    @ViewChild("tableChild") tableChild: DataTableComponent<ProviderDto>;
  pagePath: string = "api/provider/page";
  search: any;
  searchText: string = '';
  options = {
    columnTitles: ["PROVIDERS.TABLE.ID", "USERS.TABLE.FULL_NAME", "PROVIDERS.TABLE.RFC", "GENERAL.LABELS.ACTIONS"],
    columnReferences: ["id", 'name', "rfc", "actions"],
    actionButtons: { edit: true, delete: true }
  };

  constructor(private router: Router, public dialog: MatDialog, private apiService: ApiService, private messageService: MessageService) {

  }

  goToEdit(e: any) {
    this.router.navigate(["providers/edit", e.id]);
  }

  openDeleteDialog(e: any) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '680px',
      data: {
        title: 'DIALOGS.DELETE_PROVIDER.TITLE',
        body: 'DIALOGS.DELETE_PROVIDER.BODY',
        cancelButtonText: "GENERAL.LABELS.CANCEL",
        confirmButtonText: "GENERAL.LABELS.DELETE",
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.apiService.delete('api/provider/' + e.id).subscribe(data => {
          this.messageService.success("Exito", "El proveedor fue removido exitosamente");
          this.tableChild.loadPage();
        }, error => {
          this.messageService.error("Error", error.message);
        })
      }
    });
  }

  searchProvider(){
    this.search = {
      searchText: this.searchText
    }
    this.tableChild.firstPage();
    this.tableChild.loadPage(this.search);
  }
}